<!-- 必读指南 -->
<template>
  <div id='guidePage' class="main">
    <h1 class="h1">{{title}}</h1>
    <div v-for="(item,index) in contents" :key="index">
      <h5>{{item.title}}</h5>
      <p v-html="item.content"></p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: '未来魔法校  校长岗位定义',
      contents: [
        { title: '尊敬的合作校校长，您好！', content: '&nbsp;&nbsp;&nbsp;&nbsp;未来魔法校很荣幸能与贵校达成合作，魔法校校长类型产品致力于挖掘有志于教学事业的校长和创业者，通过提供可信赖的服务和培训，与合作校共同成长，帮助更多K12培训机构做的更强，同时也让更多的孩子能够享受到优质的教学资源。好未来经过15年K12教育机构的管理经验和校长培养方法的提炼，通过实战我们沉淀了校长培训体系，魔法校校长服务在此体系下，诚聘好未来集团核心高管作为指导讲师，并通过伴跑式的校长管理和服务助力机构运营发展。' },
        { title: '一、未来魔法校 校长职责', content: '1、梳理并传递健康的企业文化；搭建更科学的组织架构，培养高效团队<br/>2、推动企业文化、教育理念落地；领导团队达成业务目标；<br/>3、推动双师课堂落地，能够掌控双师项目的规划和发展；<br/>4、选择、聘用学科、教学、设备负责的老师，领导并监督其相关工作；<br/>5、配合未来魔法校总部进行运营、管理工作；' },
        { title: '二、未来魔法校 校长营活动', content: '&nbsp;&nbsp;&nbsp;&nbsp;MS魔法校长营隶属于好未来集团未来魔法项目下，致力于发掘有志于教育事业的校长和创业者，用可信赖的培训和服务，与合作机构共同成长。<br/>&nbsp;&nbsp;&nbsp;&nbsp;本期校长营历时三天，由教育行业发展、前沿教育科技、机构管理、业务共赢、好未来特色活动拓展等模块构成，充实的日程安排，只为与您深度分享好未来15年教培行业沉淀，全方位助力机构成长！' },
        { title: '三、未来魔法校 校长后续工作', content: '1、月度运营沟通反馈<br/> &nbsp;内容：本月重点工作（校区运营情况）、工作计划、客户心声、培训反思<br/>2、合作校月度分享会<br/> &nbsp;&nbsp;内容：关键时间节点邀请学科、教研、教学做交付分享，结合运营内容分享/反馈解决方案/（预告、活动）/ MS校长运营工作总结、校长分享会（每周两位，确定主题：运营/教学/学科）<br/>3、组织开展双师课堂开课动员会<br/>4、组织开展双师课堂结课反思会<br/> &nbsp;&nbsp;内容：回顾目标、评估结果、分析原因、总结经验、下学期规划、业绩排行<br/>5、日常交流<br/> &nbsp;&nbsp;内容：问题及时交流/学习其他机构等<br/>6、年终校长大会<br/> &nbsp;&nbsp;内容：机构业绩分享/优秀机构表彰/行业、机构分析报告/新年目标和规划/互动答疑' },
        { title: '四、校长分级考核', content: '1、培训考核<br/>（1）考勤<br/>（2）文化理念认同度<br/>（3）双师模式认同度<br/>（4）业务目标认同度<br/>（5）规划清晰度<br/>2、机构能力模型<br/>（1）文化<br/>（2）领导力<br/>（3）组织结构<br/>（4）业务规模<br/>3、校长领导力模型<br/>（1）以身作则<br/>&nbsp;&nbsp;&nbsp;&nbsp;身先士卒   责任心   上进心   事业心<br/>（2）关怀下属<br/>&nbsp;&nbsp;&nbsp;&nbsp;尊重下属   梳理通道   培养能力   举荐贤才<br/>（3）正直公正<br/>&nbsp;&nbsp;&nbsp;&nbsp;诚信   正直   公私分明   创造公平环境<br/>（4）空杯心态<br/>&nbsp;&nbsp;&nbsp;&nbsp;客观看待自己   寻找自身原因  主动改进   虚怀若谷<br/>（5）引领方向<br/>&nbsp;&nbsp;&nbsp;&nbsp;拥抱变化   长远眼光   前瞻部署   用心领导' }
      ]
    }
  },
  components: {},
  created () { },
  methods: {}
}
</script>
<style scoped lang='scss'>
#guidePage {
  text-align: left;
}
.main {
  height: 100%;
  width: 1180px;
  padding: 60px 20px;
  background-color: #fff;
  border-radius: 12px;
  margin: 20px auto;
  .h1{
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 60px;
    text-align: center;
  }
  h5{
    font-size: 24px;
    margin-bottom: 15px;
    margin-top: 30px;
  }
  p{
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
  }
}
</style>
